// extracted by mini-css-extract-plugin
export default {"screen":"LoadingScreen_screen__zEZSd"};